<template>
  <div>
    <h4>{{ data.properties.name }}</h4>
    <div v-if="typeof data.value !== 'undefined'" >
      {{ data.values[0].Name }}: {{ data.formatter(data.value) }}
    </div>
    <div v-if="data.values.length > 1 && typeof data.value2 !== 'undefined'" >
      {{ data.values[1].Name }}: {{ data.formatter2(data.value2) }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      required: true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/graphs/MapFeaturePopover.vue